import { render, staticRenderFns } from "./pagamenti.vue?vue&type=template&id=22d77568&scoped=true&"
import script from "./pagamenti.vue?vue&type=script&lang=js&"
export * from "./pagamenti.vue?vue&type=script&lang=js&"
import style0 from "./pagamenti.vue?vue&type=style&index=0&id=22d77568&scoped=true&lang=css&"
import style1 from "./pagamenti.vue?vue&type=style&index=1&lang=css&"
import style2 from "./pagamenti.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d77568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBottomSheet,VBtn,VCard,VDivider,VFlex,VIcon,VImg,VListItem,VListItemTitle,VSheet,VTextField,VToolbar})
